<template>
  <section class="team-circles-2 wf-section">
    <div class="container-6">
      <div v-if="loading" class="custom-loader-wrapper">
        <div class="custom-loader"></div>
      </div>
      <div v-if="!loading && $store.state.searchQuery && filteredItems.length > 0" class="search-results-header">
        <p class="search-results-info">
          Found <strong>{{ filteredItems.length }}</strong> result{{ filteredItems.length !== 1 ? 's' : '' }} for 
          <span class="search-query-badge">"{{ $store.state.searchQuery }}"</span>
        </p>
      </div>
      <div v-if="!loading && filteredItems.length > 0" class="team-grid-2">
        <div
          v-for="data in filteredItems"
          :key="data.id"
          id="w-node-_944ed45d-0b36-0fe2-68a3-da8baa79c596-5f1c185e"
          class="team-card-2"
        >
          <a :href="'/single-article?id=' + data.id" class="card-wrapper">
            <img :src="data.image" loading="lazy" alt="article" class="team-member-image-2" />
            <div class="newdetailsdiv">
              <div class="team-member-name-2 newslink" v-html="highlightText(data.title, $store.state.searchQuery)"></div>
              <div v-html="highlightText(data.content, $store.state.searchQuery)" class="team-member-position-2"></div>
              <!-- <p class="newsdate">
              {{
                new Date(data.date).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </p> -->
            </div>
          </a>
        </div>
        <!-- 
        <div
          id="w-node-_944ed45d-0b36-0fe2-68a3-da8baa79c596-5f1c185e"
          class="team-card-2"
        >
          <img
            src="images/1_1.jpg"
            loading="lazy"
            alt=""
            class="team-member-image-2"
          />
          <div class="newdetailsdiv">
            <div class="team-member-name-2">
              <a href="/single-article" class="newslink"
                >Charity for needy People, make a difference in their lives</a
              >
            </div>
            <div class="team-member-position-2">
              We were established as a EverCare ond charity in 1990 and began to
              operate and some verition.
            </div>
            <p class="newsdate">15 May 23</p>
          </div>
        </div>
        <div
          id="w-node-_16fe75e7-251c-c0e5-e339-559f6ca11bf5-5f1c185e"
          class="team-card-2"
        >
          <img
            src="images/2_1.jpg"
            loading="lazy"
            alt=""
            class="team-member-image-2"
          />
          <div class="newdetailsdiv">
            <div class="team-member-name-2">
              <a href="/single-article" class="newslink"
                >Charity for needy People, make a difference in their lives</a
              >
            </div>
            <div class="team-member-position-2">
              We were established as a EverCare ond charity in 1990 and began to
              operate and some verition.
            </div>
            <p class="newsdate">15 May 23</p>
          </div>
        </div>
        <div
          id="w-node-_536f325e-061c-5f12-5d4e-e147bfe5f28a-5f1c185e"
          class="team-card-2"
        >
          <img
            src="images/3_1.jpg"
            loading="lazy"
            alt=""
            class="team-member-image-2"
          />
          <div class="newdetailsdiv">
            <div class="team-member-name-2">
              <a href="/single-article" class="newslink"
                >Charity for needy People, make a difference in their lives</a
              >
            </div>
            <div class="team-member-position-2">
              We were established as a EverCare ond charity in 1990 and began to
              operate and some verition.<strong><br /></strong>
            </div>
            <p class="newsdate">15 May 23</p>
          </div>
        </div>
        <div
          id="w-node-_13b968d9-ded0-7a65-5527-d942884a6e6a-5f1c185e"
          class="team-card-2"
        >
          <img
            src="images/1_1.jpg"
            loading="lazy"
            alt=""
            class="team-member-image-2"
          />
          <div class="newdetailsdiv">
            <div class="team-member-name-2">
              <a href="/single-article" class="newslink"
                >Charity for needy People, make a difference in their lives</a
              >
            </div>
            <div class="team-member-position-2">
              We were established as a EverCare ond charity in 1990 and began to
              operate and some verition.
            </div>
            <p class="newsdate">15 May 23</p>
          </div>
        </div>
        <div
          id="w-node-_96dac795-33c4-3678-36e5-ccbee9e267c1-5f1c185e"
          class="team-card-2"
        >
          <img
            src="images/2_1.jpg"
            loading="lazy"
            alt=""
            class="team-member-image-2"
          />
          <div class="newdetailsdiv">
            <div class="team-member-name-2">
              <a href="/single-article" class="newslink"
                >Charity for needy People, make a difference in their lives</a
              >
            </div>
            <div class="team-member-position-2">
              We were established as a EverCare ond charity in 1990 and began to
              operate and some verition.
            </div>
            <p class="newsdate">15 May 23</p>
          </div>
        </div>
        <div
          id="w-node-_1eeb25ca-594e-5845-355b-9c46558f7f91-5f1c185e"
          class="team-card-2"
        >
          <img
            src="images/3_1.jpg"
            loading="lazy"
            alt=""
            class="team-member-image-2"
          />
          <div class="newdetailsdiv">
            <div class="team-member-name-2">
              <a href="/single-article" class="newslink"
                >Charity for needy People, make a difference in their lives</a
              >
            </div>
            <div class="team-member-position-2">
              We were established as a EverCare ond charity in 1990 and began to
              operate and some verition.<strong><br /></strong>
            </div>
            <p class="newsdate">15 May 23</p>
          </div>
        </div> 
      --></div>
      <div v-if="!loading && filteredItems.length === 0 && $store.state.searchQuery" class="no-results">
        <div class="no-results-content">
          <h3>No Articles Found</h3>
          <p>No articles found matching <strong>"{{ $store.state.searchQuery }}"</strong></p>
          <p class="no-results-suggestion">Try searching with different keywords or browse all articles.</p>
        </div>
      </div>
      <div v-else-if="!loading && items.length === 0 && !$store.state.searchQuery" class="no-results">
        <div class="no-results-content">
          <h3>No Articles Available</h3>
          <p>There are currently no articles available.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: "Articles",
  data() {
    return {
      items: [],
      loading: false,
    };
  },
  computed: {
    filteredItems() {
      const searchQuery = this.$store.state.searchQuery?.toLowerCase().trim() || "";
      if (!searchQuery) {
        return this.items;
      }
      return this.items.filter(
        (item) =>
          item.title?.toLowerCase().includes(searchQuery) ||
          item.description?.toLowerCase().includes(searchQuery) ||
          item.content?.toLowerCase().includes(searchQuery)
      );
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    highlightText(text, query) {
      if (!text || !query || !query.trim()) {
        return text || '';
      }
      
      // Handle HTML content - if it contains HTML tags, preserve them
      const hasHtml = /<[^>]+>/.test(text);
      
      if (hasHtml) {
        // For HTML content, we need to be more careful
        // Extract text nodes and highlight them
        const searchQuery = query.trim();
        const escapedQuery = this.escapeRegex(searchQuery);
        const regex = new RegExp(`(${escapedQuery})`, 'gi');
        
        // Find and replace text nodes only (not within HTML tags)
        return text.replace(/>([^<]+)</g, (match, textContent) => {
          const highlighted = textContent.replace(regex, '<mark class="search-highlight">$1</mark>');
          return `>${highlighted}<`;
        });
      } else {
        // For plain text
        const escapedText = String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        const searchQuery = query.trim();
        const escapedQuery = this.escapeRegex(searchQuery);
        
        // Create regex to find all matches (case-insensitive)
        const regex = new RegExp(`(${escapedQuery})`, 'gi');
        
        // Replace matches with highlighted version
        return escapedText.replace(regex, '<mark class="search-highlight">$1</mark>');
      }
    },
    escapeRegex(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    loadData() {
      this.loading = true;

      var config = {
        method: "get",
        url: "https://aafia.cloudious.net/api/Articles",
        headers: {
          Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZG1pbkBhYWZpYS5jb20iLCJqdGkiOiJlYTkxYTJhOC04MTVlLTQxODUtODExYi1lODRkYzc1NDNlNGIiLCJleHAiOjE4MDI5NDE4MTcsImlzcyI6Im15c2tvb2wuYXBwIiwiYXVkIjoibXlza29vbC5hcHAifQ.0bpJYJxa8oxOSb_7f24jLGVBvCNQAuVNu4rdI96dVwM",
        },
      };

      axios(config)
        .then((response) => {
          // console.log(response);
          this.items = response.data.data ? response.data.data.reverse() : [];
          this.$store.commit("setArticles", this.items);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.items = [];
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.no-results {
  text-align: center;
  padding: 60px 20px;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-results-content {
  max-width: 600px;
  margin: 0 auto;
}

.no-results-content h3 {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.no-results-content p {
  font-size: 18px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}

.no-results-content p strong {
  color: #198754;
  font-weight: 600;
}

.no-results-suggestion {
  font-size: 16px;
  color: #999;
  font-style: italic;
  margin-top: 15px;
}

/* Search results header */
.search-results-header {
  margin-bottom: 30px;
  padding: 15px 20px;
  background-color: #f8f9fa;
  border-left: 4px solid #198754;
  border-radius: 4px;
}

.search-results-info {
  margin: 0;
  color: #333;
  font-size: 16px;
}

.search-results-info strong {
  color: #198754;
  font-weight: 700;
}

.search-query-badge {
  background-color: #198754;
  color: #fff;
  padding: 4px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
  display: inline-block;
  margin-left: 8px;
}

/* Search highlight styling */
:deep(.search-highlight) {
  background-color: #198754;
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(25, 135, 84, 0.3);
  display: inline-block;
}
</style>
